// Arjuna "A" mark rising from a field of data bits (brand logo #07).
const BITS = (() => {
  const dots = [];
  const rows = 4;
  const cols = 17;
  for (let r = 0; r < rows; r++) {
    for (let c = 0; c < cols; c++) {
      const nx = c / (cols - 1);
      const x = 6 + nx * 88;
      const center = Math.exp(-Math.pow((nx - 0.5) * 2.6, 2));
      const y = 74 + r * 7 - center * 14 + Math.sin(nx * 8) * 1.4;
      const op = Math.max(0.08, 0.3 + center * 0.5 - r * 0.06);
      dots.push({ x, y, r: 0.9 + center * 0.7, op });
    }
  }
  return dots;
})();

export default function AMark({ className = "", fill = "currentColor", ...rest }) {
  return (
    <svg
      viewBox="0 0 100 108"
      className={className}
      fill="none"
      preserveAspectRatio="xMidYMid meet"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Arjuna Space"
      role="img"
      {...rest}
    >
      <g stroke={fill} strokeWidth="5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M50 8 L26 70" />
        <path d="M50 8 L74 70" />
        <path d="M50 26 L38 60" />
        <path d="M50 26 L62 60" />
      </g>
      <g>
        {BITS.map((d, i) => (
          <circle key={i} cx={d.x} cy={d.y} r={d.r} fill="#00E5FF" opacity={d.op} />
        ))}
      </g>
    </svg>
  );
}
